var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.fetched && _vm.videos.length)?_c('Player',{attrs:{"videos":_vm.videos}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }